import React, { useEffect, useState } from "react";

const COOKIE_NAME = "eigoo_consent";
const COOKIE_VALUE = "true";
const COOKIE_MAX_AGE_DAYS = 365;

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
  const maxAge = days * 24 * 60 * 60;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

export default function CookieShield() {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (getCookie(COOKIE_NAME) === COOKIE_VALUE) return;
    // Small delay for fade-in impact
    const t = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    setCookie(COOKIE_NAME, COOKIE_VALUE, COOKIE_MAX_AGE_DAYS);
    setFadingOut(true);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-shield"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className={`cookie-shield ${fadingOut ? "cookie-shield--fade-out" : "cookie-shield--fade-in"}`}
    >
      <div className="cookie-shield__inner">
        <div className="cookie-shield__text">
          <span className="cookie-shield__label">// COOKIE SHIELD</span>
          <p>This site uses cookies to enhance your experience. By continuing, you consent to our use of cookies.</p>
        </div>
        <button
          type="button"
          onClick={accept}
          data-testid="cookie-shield-accept"
          className="cookie-shield__accept"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
